module.exports = __webpack_public_path__ + "static/media/test.2b9a2cc9.png";